<div class="c2-kalender-col">
    <app-kalender></app-kalender>
</div>
<div class="c2-documenten-col">
    <app-documenten></app-documenten>
</div>


